import React from 'react';
import { InsidePagesCarousel } from '../InsidePagesCarousel';
import { Accent, SectionHeading } from './SectionHeading';

/** Section 6 — show, don't just tell. */
export function InsideSection() {
  return <section aria-labelledby="inside-heading" className="bg-brand-ivory px-5 py-16 lg:px-8 lg:py-24" data-id="element-119" data-mp="2h5myusnjle89">
      <div className="mx-auto max-w-6xl" data-id="element-120" data-mp="2d3rzvut33cxn">
        <SectionHeading id="inside-heading" eyebrow="Real Pages From Volume 4" title={<>
              This Isn't a Collection of PDFs You Read Once.{' '}
              <span className="block" data-id="element-122" data-mp="238q80r7fbwrd">
                <Accent data-id="element-123" data-mp="1y6sjpik62brk">It's a System You Actually Use.</Accent>
              </span>
            </>} body="A look inside the Student Practice & Skills Workbook — mapping, troubleshooting, client challenges, practice logs and readiness audits your students actually work through." data-id="element-121" data-mp="2d2qmhjoliecr" />

        <div className="mt-12" data-id="element-124" data-mp="3ojqba5bqib21">
          <InsidePagesCarousel data-id="element-125" data-mp="3okrpgio1rdnz" />
        </div>
      </div>
    </section>;
}